const WaterEc = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2 27.2V23.8H6.8V20.4H10.2V17H13.6V20.4H17V23.8H13.6V27.2H10.2ZM11.9 34C8.61333 34 5.80833 32.8383 3.485 30.515C1.16167 28.1917 0 25.3867 0 22.1C0 18.8133 1.16167 16.0083 3.485 13.685C5.80833 11.3617 8.61333 10.2 11.9 10.2C15.1867 10.2 17.9917 11.3617 20.315 13.685C22.6383 16.0083 23.8 18.8133 23.8 22.1C23.8 25.3867 22.6383 28.1917 20.315 30.515C17.9917 32.8383 15.1867 34 11.9 34ZM11.9 30.6C14.2517 30.6 16.2563 29.7712 17.9137 28.1138C19.5713 26.4563 20.4 24.4517 20.4 22.1C20.4 19.7483 19.5713 17.7437 17.9137 16.0863C16.2563 14.4288 14.2517 13.6 11.9 13.6C9.54833 13.6 7.54375 14.4288 5.88625 16.0863C4.22875 17.7437 3.4 19.7483 3.4 22.1C3.4 24.4517 4.22875 26.4563 5.88625 28.1138C7.54375 29.7712 9.54833 30.6 11.9 30.6ZM25.415 23.29C25.4717 23.12 25.5 22.9358 25.5 22.7375V22.1C25.5 18.3317 24.1754 15.1229 21.5263 12.4738C18.8771 9.82458 15.6683 8.5 11.9 8.5H11.2625C11.0642 8.5 10.88 8.52833 10.71 8.585C11.4467 6.09167 12.8421 4.0375 14.8962 2.4225C16.9504 0.8075 19.3517 0 22.1 0C25.3867 0 28.1917 1.16167 30.515 3.485C32.8383 5.80833 34 8.61333 34 11.9C34 14.6483 33.1925 17.0496 31.5775 19.1038C29.9625 21.1579 27.9083 22.5533 25.415 23.29Z"
        fill="#1868DB"
      />
    </svg>
  );
};

export default WaterEc;
